export default {"src":"/_next/static/media/qlc.78722fd9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};